module.exports = __webpack_public_path__ + "img/S1DV.f95a29f5.svg";